import React from "react";

import { connect } from "react-redux";
import { SSOAuth } from "../../components/SSO";
import { withRouter } from "../../utils/withRouter";
import { TermsAndCondition } from "../../components/TermsAndCondition";

class SSOAuthScreen extends React.Component {
  render() {
    console.log("env:", process.env);
    return (
      <>
        <SSOAuth redirectToken={this.props.searchParams.get("redirectToken")} />
        <TermsAndCondition />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(withRouter(SSOAuthScreen));
